import type { FormElement, HeaderProperties } from '../model/form.types';

export interface HeaderRecordFields {
  prefix: string;
  rev: string;
  title: string;
}

export function readHeaderRecordFields(
  elements: ReadonlyArray<FormElement>
): HeaderRecordFields {
  const header = elements.find((element) => element.type === 'HEADER');
  const properties = header?.properties as HeaderProperties | undefined;

  return {
    prefix: properties?.rq?.trim() ?? '',
    rev: properties?.rev?.trim() ?? '',
    title: properties?.title?.trim() ?? '',
  };
}

export function applyHeaderRecordFields(
  elements: ReadonlyArray<FormElement>,
  fields: HeaderRecordFields
): FormElement[] {
  return elements.map((element) => {
    if (element.type !== 'HEADER') {
      return element;
    }

    const properties: HeaderProperties = {
      ...(element.properties as HeaderProperties),
      rq: fields.prefix,
      rev: fields.rev,
      title: fields.title,
    };

    return { ...element, properties };
  });
}
